export default __webpack_public_path__ + "static/media/medicine.a8d36d0c.gif";